import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Dialog, TextInput } from "@gravity-ui/uikit";
import { Loading } from "@/layouts/components";
import { GameUserRole, GameUserStatus, useGetUsersQuery, } from "@/store/api";
import { debounce } from "@/tools/debounce";
export var UserSearchModal = function (props) {
    var dialogTitleId = "app-confirmation-dialog-title";
    var _a = useState(""), searchQuery = _a[0], setSearchQuery = _a[1];
    var debouncedSearch = debounce(setSearchQuery, 500);
    var searchChangeHandler = function (value) {
        // value.length > 2 &&
        debouncedSearch(value);
    };
    var userListGetState = useGetUsersQuery({ text: searchQuery });
    var selectUserHandler = function (user) {
        props.onConfirm({
            userName: user.username,
            userId: user.id,
            role: GameUserRole.Member,
            status: GameUserStatus.Invited,
        });
        props.onClose();
    };
    return (_jsxs(Dialog, { size: "s", onClose: props.onClose, open: props.open, "aria-labelledby": dialogTitleId, children: [_jsx(Dialog.Header, { caption: "\u0412\u044B\u0431\u043E\u0440 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F", id: dialogTitleId }), _jsxs(Dialog.Body, { children: [_jsx(TextInput, { onUpdate: searchChangeHandler, placeholder: "Поиск", style: { marginBottom: 20 } }), _jsx(Loading, { isActive: userListGetState.isFetching, loadingKey: "userList" }), userListGetState.isSuccess &&
                        userListGetState.data.items
                            .filter(function (user) { var _a; return !((_a = props.selectedUsers) === null || _a === void 0 ? void 0 : _a.includes(user.id)); })
                            .map(function (user) { return (_jsx("div", { onClick: function () { return selectUserHandler(user); }, children: user.username }, user.id)); })] }), _jsx(Dialog.Footer, { onClickButtonCancel: props.onClose, 
                // onClickButtonApply={props.onConfirm}
                // textButtonApply="Продолжить"
                textButtonCancel: "\u041E\u0442\u043C\u0435\u043D\u0430" })] }));
};
